// import { createSelector } from 'reselect';

export const getIsPosting = state => state.getIn(['forgotPassword', 'isPosting']);
export const getErrMsg = state => state.getIn(['forgotPassword', 'errMsg']);